import { FC } from "react";
import { IColumn } from "@fluentui/react";
import {
  ColumnFiltersState,
  OnColumnFilterChange,
} from "@cayo/shared/components/GridContainer/types/columnFilters";
import {
  FiltersRow,
  CheckboxSpacer,
  FilterCell,
  FilterPlaceholder,
  GroupChevronSpacer,
} from "./ColumnFilters.styles";
import { ColumnFilterField } from "./components/ColumnFilterField";
import { getColumnWidth, isFilterableColumn } from "./utils";

interface ColumnFiltersProps {
  columns: ReadonlyArray<IColumn>;
  isGrouped: boolean;
  columnFilters?: ColumnFiltersState;
  onColumnFilterChange: OnColumnFilterChange;
}

export const ColumnFilters: FC<ColumnFiltersProps> = ({
  columns,
  isGrouped,
  columnFilters = {},
  onColumnFilterChange,
}) => {
  if (!columns.length) {
    return null;
  }

  return (
    <FiltersRow onClick={(event) => event.stopPropagation()}>
      <CheckboxSpacer />
      {isGrouped && <GroupChevronSpacer />}
      {columns.map((column) => {
        const fieldName = column.fieldName ?? column.key;
        const columnWidth = getColumnWidth(column);

        return (
          <FilterCell key={column.key} $width={columnWidth}>
            {isFilterableColumn(column) ? (
              <ColumnFilterField
                column={column}
                value={columnFilters[fieldName] ?? ""}
                onColumnFilterChange={onColumnFilterChange}
              />
            ) : (
              <FilterPlaceholder />
            )}
          </FilterCell>
        );
      })}
    </FiltersRow>
  );
};
